import React, { useEffect, useState } from 'react'
import { ReactComponent as LocationIcon } from '../../../assets/icons/location.svg';
import { ReactComponent as WhatsappIcon } from '../../../assets/plus_icon/whats_app.svg';
import { ReactComponent as CallIcon } from '../../../assets/icons/call.svg';
import { ReactComponent as ThreedotsIcon } from '../../../assets/icons/threedots.svg';
import TooltipText from '../../../components/Tooltip';
import SitevisitDetailsModal from '../Modal/SitevisitDetailsModal';
import RequestToken from '../Modal/RequestToken';
import RequestBooking from '../Modal/RequestBooking';
import { getAllSitevisit, getBrokerSiteVisit } from '../../../services/private/plus.leads.service';
import { ReactComponent as Searchicon } from '../../../assets/icons/searchicon.svg';
import moment from 'moment';
import SitevisitReScheduleModal from '../Modal/sitevisitReScheduleModal';
import ScheduleSiteVisitModal from '../Modal/ScheduleSiteVisitModal';
import Slider from 'react-slick';
import { toast } from 'react-toastify';
import { ReactComponent as NoLeadsIcon } from '../../../assets/plus_icon/no_leads.svg';

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={`${className} !-right-[9px] z-10`}
            onClick={onClick}
        >
            {/* <RightSlideIcon /> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M24 4C24 1.79086 22.2091 0 20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4Z" fill="#F1F1F5" /><path fillRule="evenodd" clipRule="evenodd" d="M13.5858 12L9.29289 16.2929C8.90237 16.6834 8.90237 17.3166 9.29289 17.7071C9.68342 18.0976 10.3166 18.0976 10.7071 17.7071L15.7071 12.7071C16.0976 12.3166 16.0976 11.6834 15.7071 11.2929L10.7071 6.29289C10.3166 5.90237 9.68342 5.90237 9.29289 6.29289C8.90237 6.68342 8.90237 7.31658 9.29289 7.70711L13.5858 12Z" fill="#171725" /><path d="M20 0.5H4V-0.5H20V0.5ZM0.5 4V20H-0.5V4H0.5ZM4 23.5H20V24.5H4V23.5ZM23.5 20V4H24.5V20H23.5ZM20 23.5C21.933 23.5 23.5 21.933 23.5 20H24.5C24.5 22.4853 22.4853 24.5 20 24.5V23.5ZM0.5 20C0.5 21.933 2.067 23.5 4 23.5V24.5C1.51472 24.5 -0.5 22.4853 -0.5 20H0.5ZM4 0.5C2.067 0.5 0.5 2.067 0.5 4H-0.5C-0.5 1.51472 1.51472 -0.5 4 -0.5V0.5ZM20 -0.5C22.4853 -0.5 24.5 1.51472 24.5 4H23.5C23.5 2.067 21.933 0.5 20 0.5V-0.5Z" fill="#E2E2EA" /></svg>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={`${className} !-left-[13px] z-10`}
            onClick={onClick}
        >
            {/* <LeftSlideIcon /> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="#F1F1F5" /><path fillRule="evenodd" clipRule="evenodd" d="M10.4142 12L14.7071 16.2929C15.0976 16.6834 15.0976 17.3166 14.7071 17.7071C14.3166 18.0976 13.6834 18.0976 13.2929 17.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L13.2929 6.29289C13.6834 5.90237 14.3166 5.90237 14.7071 6.29289C15.0976 6.68342 15.0976 7.31658 14.7071 7.70711L10.4142 12Z" fill="#171725" /><path d="M4 0.5H20V-0.5H4V0.5ZM23.5 4V20H24.5V4H23.5ZM20 23.5H4V24.5H20V23.5ZM0.5 20V4H-0.5V20H0.5ZM4 23.5C2.067 23.5 0.5 21.933 0.5 20H-0.5C-0.5 22.4853 1.51472 24.5 4 24.5V23.5ZM23.5 20C23.5 21.933 21.933 23.5 20 23.5V24.5C22.4853 24.5 24.5 22.4853 24.5 20H23.5ZM20 0.5C21.933 0.5 23.5 2.067 23.5 4H24.5C24.5 1.51472 22.4853 -0.5 20 -0.5V0.5ZM4 -0.5C1.51472 -0.5 -0.5 1.51472 -0.5 4H0.5C0.5 2.067 2.067 0.5 4 0.5V-0.5Z" fill="#E2E2EA" /></svg>

        </div>
    );
}

const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: true,
    // centerMode: true,
    // centerPadding: '60px',
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
};

const Sitevisits = ({ leads, handleGetLeads, handleShowSitevisiModal, setSelectedTimelineLead, setShowTimeline, userProfile, users }) => {
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showRequestTokenModal, setShowRequestTokenModal] = useState(false);
    const [showRequestBookingModal, setShowRequestBookingModal] = useState(false);
    const [selectedLead, setSelectedLead] = useState({});
    const [showReScheduleModal, setShowReScheduleModal] = useState(false);
    const [showSitevisitModal, setShowSitevisitModal] = useState(false);
    const [projectIndex, setProjectIndex] = useState(0);
    const [selectedProject, setSelectedProject] = useState({})

    const handleGetSVDetails = async (lead) => {
        try {
            const res = await getBrokerSiteVisit(lead?.uuid);
            if (res.data.status === 200) {
                setSelectedLead(res.data.data);
                setShowDetailModal(true)
            }
        } catch (err) {
            console.log({ err })
        }
    }

    return (
        <div className='space-y-4 h-[70vh] overflow-y-auto overflow-x-hidden'>
            {
                leads?.length > 0 && leads.map((lead, index) => (
                    <div className='!p-3.5 border rounded-[10px] lead-card-shadow w-full' key={`${lead.customer_name}_${index}`}>
                        <div className='flex justify-between'>
                            <div className=''>
                                <h2 className='text-base font-bold text-textblack'>{lead?.customer_name}</h2>
                                {/* <p className='m-0 text-xs text-black700'>12:10 PM, 24 June</p> */}
                            </div>
                            <div className='flex items-center space-x-4'>
                                <a className='' href={`https://wa.me/${lead?.customer_mobile}`} target='_blank'>
                                    <WhatsappIcon className='w-8 h-8' />
                                </a>

                                <button onClick={() => {
                                    navigator.clipboard.writeText(lead.customer_mobile).then(function () {
                                        toast.success('Mobile number Copied');
                                    }, function (err) {
                                        toast.error('Could not copy');
                                    });
                                }}>
                                    <TooltipText title={lead.customer_mobile}>
                                        <CallIcon className=' stroke-black800 w-6 h-6' />
                                    </TooltipText>
                                </button>
                                <button
                                    className='border border-primary rounded-lg text-primary text-sm font-medium py-1.5 !px-3 primary-button hover:!text-white'
                                    onClick={() => {
                                        setSelectedLead(lead);
                                        setShowSitevisitModal(true);
                                    }}
                                >
                                    + Add Project for Visit
                                </button>
                                {/* <button>
                            <ThreedotsIcon />
                        </button> */}
                                {/* <div className="filter-btn mr-12">
                            <button className={`d-flex align-items-center border-0 btn`} type="button">
                                <ThreedotsIcon />
                            </button>
                        </div> */}
                                <div className="dropdown view-more d-flex">
                                    <button className="bg-tr border-0 px-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <ThreedotsIcon />
                                    </button>
                                    <div className="dropdown-menu w-auto dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <div className="head-itme pb-2 text-black700 text-xs font-medium m-0">Add <span></span></div>
                                        <a
                                            className="dropdown-item mb-8 text-sm"
                                            onClick={() => {
                                                setSelectedLead(lead);
                                                setShowSitevisitModal(true);
                                            }}
                                        > Add Project For Visit </a>

                                        {/* <div className="head-itme text-black700 text-xs font-medium">Actions <span style={{ width: '80px' }}></span></div>                                      
                                        <a className="dropdown-item text-sm" onClick={() => {
                                            setShowReScheduleModal(true);
                                            setSelectedLead(lead)
                                        }}>Re-schedule Site Visit</a> */}

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='!my-4'>
                            <p className='m-0 text-black800 text-xs font-medium flex items-center'>Projects({lead?.site_visits?.length}) <span className='border-t border-dashed w-full inline-block !ml-1'></span></p>
                        </div>
                        {
                            lead?.site_visits.length <= 4 && <div className='flex !gap-4'>
                                {lead.site_visits.map((item, pIndex) => (
                                    <div className='!p-3 w-[296px] border rounded-xl cursor-pointer sv-card' onClick={() => {
                                        // setSelectedLead(lead)
                                        setProjectIndex(pIndex);
                                        setSelectedProject(item)
                                        // setShowDetailModal(true)
                                        handleGetSVDetails(item)
                                    }}>
                                        <p className='m-0 text-black800 text-xs w-max font-semibold !py-1 px-2.5 leads-project project-name rounded-lg'>{item?.project_name}</p>
                                        <div className='!mt-3 flex flex-row'>
                                            <div className='flex flex-col items-center !mr-2 w-8 grow-1 shrink-1 basis-8'>
                                                <div className='rounded-full bg-grey-light flex items-center'>
                                                    <LocationIcon className=' fill-black800 ' />
                                                </div>
                                                <div className='border-l !mt-1 !h-[calc(100%-24px)]'></div>
                                            </div>
                                            <div className='flex w-full flex-col items-start !mt-2'>
                                                <p className='m-0 text-black800 text-sm font-semibold leading-5'>Site Visit {!item.is_completed ? 'Scheduled' : 'Completed'} {item.type ? `(${item.type})` : ''} </p>
                                                {!item?.tagging_validity && <p className='mb-0 text-xs text-black700 font-medium leading-5 !mt-1'>{moment(item.schedule_date).format('hh:mm a Do MMM YYYY')}</p>}
                                                {item?.tagging_validity > 0 && <p className='mb-0 text-xs font-medium leading-5 text-[#32BA7C]'>Tagging: <span className='capitalize'>{item?.tagging_validity ? `${item?.tagging_validity + 1} ${item?.tagging_validity_unit} left` : '-'}</span></p>}
                                                {item?.assigned_to && <p className='mb-0 text-xs text-black700 font-medium leading-5 '>Assigned to: <span className='capitalize'>{item.assigned_to}</span></p>}
                                            </div>
                                        </div>
                                    </div>
                                ))
                                }
                            </div>}
                        {lead.site_visits.length > 4 &&
                            <div className='!w-full site-visit-slider'>
                                <Slider {...settings}>
                                    {lead.site_visits.map((item, pIndex) => (
                                        <div className=''>
                                            <div className='!p-3 !w-[296px] border rounded-xl cursor-pointer sv-card !mr-4' onClick={() => {
                                                // setSelectedLead(lead)
                                                setProjectIndex(pIndex);
                                                setSelectedProject(item)
                                                // setShowDetailModal(true)
                                                handleGetSVDetails(item)
                                            }}>
                                                <p className='m-0 text-black800 text-xs w-max font-semibold !py-1 px-2.5 leads-project project-name rounded-lg'>{item?.project_name}</p>
                                                <div className='!mt-3 flex flex-row'>
                                                    <div className='flex flex-col items-center !mr-2 w-8 grow-1 shrink-1 basis-8'>
                                                        <div className='rounded-full bg-grey-light flex items-center'>
                                                            <LocationIcon className=' fill-black800 ' />
                                                        </div>
                                                        <div className='border-l !mt-1 !h-[calc(100%-24px)]'></div>
                                                    </div>
                                                    <div className='flex w-full flex-col items-start !mt-2'>
                                                        <p className='m-0 text-black800 text-sm font-semibold leading-5'>Site Visit {!item.is_completed ? 'Scheduled' : 'Completed'} {item.type ? `(${item.type})` : ''} </p>
                                                        {!item?.tagging_validity && <p className='mb-0 text-xs text-black700 font-medium  leading-5 !mt-1'>{moment(item.schedule_date).format('hh:mm a Do MMM YYYY')}</p>}
                                                        {item?.tagging_validity > 0 && <p className='mb-0 text-xs font-medium leading-5 text-[#32BA7C]'>Tagging: <span className='capitalize'>{item?.tagging_validity ? `${item?.tagging_validity + 1} ${item?.tagging_validity_unit} left` : '-'}</span></p>}
                                                        {item?.assigned_to && <p className='mb-0 text-xs text-black700 font-medium leading-5 '>Assigned to: <span className='capitalize'>{item.assigned_to}</span></p>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    }
                                </Slider>
                            </div>
                        }

                    </div>
                ))
            }
            {
                leads?.length === 0 && <div className='flex flex-col items-center justify-center w-100 h-100' >
                    <figure>
                        {/* <Searchicon /> */}
                        <NoLeadsIcon />
                    </figure>
                    {/* <img src="https://s3-alpha-sig.figma.com/img/4b8f/0eed/ff5e65443c4cdc463ac9562c41307b20?Expires=1729468800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Qc-5lwQHV6BvtbPCF~64Y0XIpAyb08K5QNIKquRxhbl31M512e-FG1ecBem5nzyJCzdy-t3DpMQJsN75z7KxlJgOAYnS7qXr0HRnJQHs6xd-72OQHzUhPbijNxncOBJ3B1Ydc-u7enI-ri9Ssx6kWdFjQnxirebej4TkbgKW51mywWjihX4PF4aIaty6RuTLTU~GXOPf6wnZWsxlXUgi7ABFEH2vi4UyeesLRxq8h2kl3dQyZmXDy1r6b9rNYp4Pa5IvGR3PG4~yvu-xbDJeA~BIAJufpAByyrqD6cJtKcxs2epEGMzQlwgxJ1XHuRLsJUdJp8LGxkpGpsj3iSZx0Q__" alt="" /> */}
                    <p className='text-black700 text-base'>There is no lead at the moment. <br /> Add new lead to start working on it!</p>
                    <button
                        className='border rounded-lg text-white gradient-blue text-sm font-medium py-1.5 !px-3'
                        onClick={() => handleShowSitevisiModal(true)}
                    >
                        + Add Lead
                    </button>
                </div>
            }
            {showDetailModal && Object.keys(selectedLead).length && <SitevisitDetailsModal
                show={showDetailModal}
                closeModal={() => setShowDetailModal(false)}
                selectedLead={selectedLead}
                // selectedLead={selectedProject}
                setShowReScheduleModal={setShowReScheduleModal}
                setShowSitevisitModal={setShowSitevisitModal}
                projectIndex={projectIndex}
                setSelectedTimelineLead={setSelectedTimelineLead}
                setShowTimeline={setShowTimeline}
            />}
            {showReScheduleModal && Object.keys(selectedLead).length &&
                <SitevisitReScheduleModal
                    show={showReScheduleModal}
                    selectedLead={selectedLead}
                    closeModal={() => {
                        setShowReScheduleModal(false)
                        setSelectedLead({})
                    }}
                    handleGetLeads={handleGetLeads}
                    userProfile={userProfile}
                    users={users}
                />}

            {
                showSitevisitModal && <ScheduleSiteVisitModal
                    show={showSitevisitModal}
                    selectedLead={selectedLead}
                    closeModal={() => {
                        setShowSitevisitModal(false)
                        setSelectedLead({})
                    }}
                    handleGetLeads={handleGetLeads}
                    userProfile={userProfile}
                    users={users}
                />
            }

            {showRequestTokenModal && <RequestToken show={showRequestTokenModal} closeModal={() => setShowRequestTokenModal(false)} />}
            {showRequestBookingModal && <RequestBooking show={showRequestBookingModal} closeModal={() => setShowRequestBookingModal(false)} />}
        </div>
    )
}

export default Sitevisits